import { downArrow } from 'icons/downArrow.js';
import { mute } from 'icons/mute.js';
import { pause } from 'icons/pause.js';
import { play } from 'icons/play.js';
import { sound } from 'icons/sound.js';
import './mediaControls.scss';

export const MediaControlsTemplate = (model) => {
	const { id, color = '#403F42', isFooter, showControls = false } = model;
	const btnId = isFooter ? 'control' : id;

	const rateOptions = () => {
		const options = [0.25, 0.5, 0.75, 1, 1.25, 1.5, 1.75, 2];
		let optionsHTML = '';
		options.map((rate) => {
			/* html */
			optionsHTML += `<li tabindex="-1" onkeydown="ENGT_CHAT.onEnterPress()" data-value="${rate}">${rate}x</li>`;
		});
		return optionsHTML;
	};

	const playbackRateHTML = rateOptions();

	/* html */
	const playPause = `
        <span tabindex="0" role="button" onkeydown="ENGT_CHAT.onEnterPress()" class="engt-controls-btn" 
            id="engt-play-${btnId}" aria-label="play">
                ${play(color)}
        </span>
        <span tabindex="0" role="button" onkeydown="ENGT_CHAT.onEnterPress()" 
        class="engt-controls-btn engt-hidden" id="engt-pause-${btnId}" aria-label="pause">
            ${pause(color)}
        </span>
    `;

	/* html */
	const html = `
        ${showControls ? '' : playPause}
        <input id="engtMediaProgress-${btnId}" class="engt-media-progress" type="range" min="0" max="100" step="1" value="0">
        <div class="engt-media-control-btns">
            ${showControls ? playPause : ''}
            <span class="engt-controls-speed">
                <span tabindex="0" role="button" onkeydown="ENGT_CHAT.onEnterPress()" class="engt-controls-btn" 
                id="engt-vol-${btnId}" aria-label="mute">
                    ${sound(color)}
                </span>
                <input id="engtVolProgress-${btnId}" class="engt-volume-progress" type="range" min="0" max="1" step="0.1" value="1">
                <span tabindex="0" role="button" onkeydown="ENGT_CHAT.onEnterPress()" 
                class="engt-controls-btn engt-hidden" id="engt-mute-${btnId}" aria-label="unmute">
                    ${mute(color)}
                </span>
            </span>
            <span id="engtMediaTime-${btnId}" class="engt-media-time" style="color: ${color}">0:00 / -</span>
            <span class="engt-controls-speed engt-playback-rate" id="engtSpeed-${btnId}">
                <span id="engtRateText-${btnId}" style="color: ${color}; text-align: right;">1x</span>
                <span tabindex="0" role="button" onkeydown="ENGT_CHAT.onEnterPress()" style="height: 24px;" 
                class="engt-controls-btn" id="engt-rate-${btnId}" aria-label="change playback rate">
                    ${downArrow(color)}
                </span>
                <span id="engtRateWrapper-${btnId}" class="engt-playback-rate-wrapper">
                    <ul id="engtRateItems-${btnId}" class="engt-playback-rate-ul">
                    ${playbackRateHTML}
                    </ul>
                </span>
            </span>
        </div>
    `;

	return html;
};
